export default "__VITE_ASSET__DzcgMoTN__"